export const WITHDRAWAL_MESSAGES = {
  pendingCustomerPayment: "درانتظار پرداخت تکمیلی مشتری. امکان ثبت درخواست برداشت وجه وجود ندارد.",
  minimumAmount: "مجموع مبلغ انتخاب شده باید حداقل ۱۰٬۰۰۰٬۰۰۰ ریال باشد.",
  agentsOnly: "فقط مشاوران امکان ثبت درخواست برداشت دارند.",
  genericError: "خطا در ثبت درخواست برداشت",
};

const API_ERROR_MESSAGES = {
  "Some selected wallet transactions are invalid or already withdrawn": WITHDRAWAL_MESSAGES.pendingCustomerPayment,
  "Withdrawal amount must be at least 10000000": WITHDRAWAL_MESSAGES.minimumAmount,
  "Withdrawal amount must equal selected wallet transactions amount": "مبلغ برداشت باید با مجموع درآمدهای انتخاب شده برابر باشد.",
  "Duplicate wallet_transaction_ids are not allowed": "یک درآمد بیش از یک بار انتخاب شده است. لطفاً انتخاب ها را بررسی کنید.",
  "Insufficient balance": "موجودی کیف پول کافی نیست.",
  "Only agents can withdraw": WITHDRAWAL_MESSAGES.agentsOnly,
};

export const getWithdrawalErrorMessage = (message) => {
  if (API_ERROR_MESSAGES[message]) {
    return API_ERROR_MESSAGES[message];
  }

  if (typeof message === "string" && /[\u0600-\u06FF]/.test(message)) {
    return message;
  }

  return WITHDRAWAL_MESSAGES.genericError;
};
